<div class="rootClass">
  <mat-sidenav-container *ngIf="header" class="sidenav-container">
    <mat-sidenav class="sidenavTotal" #sidenav>
      <div class="sidenavContainer">
        <div class="sectionSidenavTop">
          <!-- <div class="sectionSidenavUser">
            <div class="sectionSidenavTextUser">NombreUser</div>
            <div style="width: 37px; height: 37px; border-radius: 100%; background-color: white;"></div>
          </div> -->
          <div [class]="!ubicacion.includes('/casos') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/casos')">
            <div class="sectionSidenavText">{{ "sidebar.issues" | transloco }}</div>
            <mat-icon>assignment</mat-icon>
          </div>
          <!-- <div [class]="!ubicacion.includes('/productos') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/productos')">
            <div class="sectionSidenavText">{{ "sidebar.products" | transloco }}</div>
            <mat-icon>inventory</mat-icon>
          </div> -->
          <div [class]="!ubicacion.includes('/citas') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/citas')">
            <div class="sectionSidenavText">{{ "sidebar.appointments" | transloco }}</div>
            <mat-icon>domain_disabled</mat-icon>
          </div>
          <div [class]="!ubicacion.includes('/perfil') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/perfil')">
            <div class="sectionSidenavText">{{ "sidebar.profile" | transloco }}</div>
            <mat-icon>person</mat-icon>
          </div>
          <div [class]="!ubicacion.includes('/faqs') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/faqs')">
            <div class="sectionSidenavText">{{ "sidebar.faq" | transloco }}</div>
            <mat-icon>help</mat-icon>
          </div>
        </div>
        <div class="sectionSidenavBottom">
          <!-- <div [class]="!ubicacion.includes('/configuracion') ? 'sectionSidenav' : 'sectionSidenavSelected'" (click)="navigateTo('/configuracion')">
            <div class="sectionSidenavText">{{ "sidebar.settings" | transloco }}</div>
            <mat-icon>settings</mat-icon>
          </div> -->
          <div class="sectionSidenavCerrarSesion" (click)="logout()">
            <div class="sectionSidenavText">{{ "sidebar.logout" | transloco }}</div>
            <mat-icon>cancel</mat-icon>
          </div>
        </div>
      </div>

    </mat-sidenav>
    <mat-sidenav-content>
      <app-new-header [menuButton]="buttonHeader" (sidenavToggle)="sidenav.toggle()"></app-new-header>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <div *ngIf="!header">
    <router-outlet></router-outlet>
  </div>
</div>